<template>
  <LKPublicationsFormdataListModalContainer
    ref="modal"
    title="История изменений"
    content-class="LKPublicationsFormdataHistoryListModal"
    @closed="$emit('closed')"
  >
    <LKPublicationsFormdataHistoryList
      :id="data.id"
    />
  </LKPublicationsFormdataListModalContainer>
</template>

<script>
import LKPublicationsFormdataListModalContainer from './LKPublicationsFormdataListModalContainer.vue'
import LKPublicationsFormdataHistoryList from './LKPublicationsFormdataHistoryList.vue'


export default {
  name: 'LKPublicationsFormdataHistoryListModal',
  components: {
    LKPublicationsFormdataListModalContainer,
    LKPublicationsFormdataHistoryList,
  },
  inheritAttrs: false,
  props: {
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'id' in prop
      ),
    },
  },
  methods: {
    async open() {
      await this.$nextTick()
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsFormdataHistoryListModal {
  width: 900px;
  height: auto;
  margin-right: auto;
  margin-left: auto;
}
</style>
